import React, { useEffect } from "react";
import Container from "../../components/Container";
import Navbar from "../../components/Navbar";
import QuizAddForm from "../../components/Quizzes/QuizAddForm";

export default function AddQuiz() {
  useEffect(() => {
    document.title = "Add new Quiz";
  });
  return (
    <>
      <Navbar />
      <Container>
        <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
          <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
            Add Quiz
          </h1>
          <QuizAddForm />
        </main>
      </Container>
    </>
  );
}
